export const MomentFormat = {
    DATE: 'MM/DD/yyyy',
    TIME: 'hh:mm A',
    DATE_TIME: 'MM/DD/yyyy @ hh:mm:ss A'
};